<div class="aria-widget-slider">
    <div class="labels" [attr.aria-hidden]="'true'">
        <p>
            <span id="aria-desc-min" hSrOnlyNoSnippet>
                <ng-container i18n="@@hermes.accessibility.minimum_price">Minimum price</ng-container>
                <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                <ng-container i18n="@@hermes.accessibility.change-value-up-and-down">
                    Use page up and page down to change the value quickly
                </ng-container>
            </span>
            <span>{{ valueMinCurrent | hCurrency : "short" }}</span>
        </p>

        <p [class.hide]="(showSlider$ | async) === false">
            <span id="aria-desc-max" hSrOnlyNoSnippet>
                <ng-container i18n="@@hermes.accessibility.maximum_price">Maximum price</ng-container>
                <ng-container i18n="@@hermes.accessibility.comma-separator">,&nbsp;</ng-container>
                <ng-container i18n="@@hermes.accessibility.change-value-up-and-down">
                    Use page up and page down to change the value quickly
                </ng-container>
            </span>
            <span>{{ valueMaxCurrent | hCurrency : "short" }}</span>
        </p>
    </div>
    <div
        class="rail-top"
        (click)="handleEventOnRailSubject.next($event)"
        (touch)="handleEventOnRailSubject.next($event)"
        [class.hide]="(showSlider$ | async) === false">
    </div>

    <div class="rail" #rail [class.hide]="(showSlider$ | async) === false">
        <div
            id="min"
            #min
            [attr.role]="'slider'"
            [attr.tabindex]="isExpanded ? 0 : -1"
            class="thumb min to-be-focused-when-opened"
            [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
            alt=""
            [attr.aria-valuemin]="valueMin"
            [attr.aria-valuenow]="ariaMinCurrent"
            [attr.aria-valuetext]="ariaMinCurrent | hCurrency : 'short'"
            [attr.aria-valuemax]="valueMax"
            [attr.aria-labelledby]="'aria-desc-min'"
            [attr.aria-live]="'polite'"
            [attr.aria-atomic]="'true'">
            <div class="dot"></div>
        </div>

        <div
            id="max"
            #max
            [attr.role]="'slider'"
            [attr.tabindex]="isExpanded ? 0 : -1"
            class="thumb max"
            [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
            alt=""
            [attr.aria-valuemin]="valueMin"
            [attr.aria-valuenow]="ariaMaxCurrent"
            [attr.aria-valuetext]="ariaMaxCurrent | hCurrency : 'short'"
            [attr.aria-valuemax]="valueMax"
            [attr.aria-labelledby]="'aria-desc-max'"
            [attr.aria-live]="'polite'"
            [attr.aria-atomic]="'true'">
            <div class="dot"></div>
        </div>

        <div class="selected" #selected> </div>
    </div>

    <div
        class="rail-bottom"
        (click)="handleEventOnRailSubject.next($event)"
        (touch)="handleEventOnRailSubject.next($event)"
        [class.hide]="(showSlider$ | async) === false">
    </div>

    <div class="svg-round-bar-grey" [class.hide]="showSlider$ | async">
        <h-svg-icon [name]="'round-bar-grey'"></h-svg-icon>
    </div>
</div>
